import React from 'react'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TrendIndicatorProps {
  value: number
  isPositive: boolean
  className?: string
}

export function TrendIndicator({ value, isPositive, className }: TrendIndicatorProps) {
  const Icon = isPositive ? TrendingUp : TrendingDown
  const colorClass = isPositive ? 'text-success' : 'text-error'
  const bgClass = isPositive ? 'bg-success-light' : 'bg-error-light'

  return (
    <div className={cn('flex items-center gap-1 px-2 py-1 rounded-md', bgClass, className)}>
      <Icon className={cn('w-4 h-4', colorClass)} />
      <span className={cn('text-xs font-semibold', colorClass)}>
        {Math.abs(value)}%
      </span>
    </div>
  )
}


